import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

import { ConditionGuideComponent } from './condition-guide.component';

@NgModule({
  imports: [CommonModule, MatDialogModule],
  exports: [ConditionGuideComponent],
  declarations: [ConditionGuideComponent]
})
export class ConditionGuideModule {}
